module.exports = __webpack_public_path__ + "img/survival_widget.f73cd798.jpg";